import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { checkSession } from "./api/client"; 
import { LoginPage } from "./pages/LoginPage";
import { useUserSession } from "./context/useUserSession";
import { UserLandingPage } from "./pages/UserLandingPage";

function App() {
  const { user, setUser } = useUserSession();
  const [checkingSession, setCheckingSession] = useState(true);

  useEffect(() => {
    const loadSession = async () => {
      try {
        const res = await checkSession();
        if (res.success && res.name) {
          setUser({ name: res.name });
        }
      } catch (err) {
        console.warn("Session check failed:", err);
      } finally {
        setCheckingSession(false);
      }
    };

    loadSession();
  }, [setUser]);

  // 🚧 Prevent routing until session is resolved
  if (checkingSession) {
    return <div>Checking session...</div>;
  }

  return (
    <Routes>
      {/* ROOT ROUTE */}
      <Route
        path="/"
        element={
          user
            ? <Navigate to="/landing" replace />
            : <LoginPage />
        }
      />

      {/* AUTHENTICATED LANDING */}
      <Route
        path="/landing"
        element={
          user
            ? <UserLandingPage />
            : <Navigate to="/" replace />
        }
      />

      {/* CATCH-ALL */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
